export default __webpack_public_path__ + "static/media/13.889f1b93.gif";